import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { postPACAB010, postPACAB010AuthOtp, postPACAC010, postPACAC010AuthOtp } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import { generateYearOptions, handleFocus } from '../../../utils';

const PACAB010 = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [prepareData, setPrepareData] = useState({});
    const [year, setYear] = useState('2000');
    const [month, setMonth] = useState(null);
    const [day, setDay] = useState(null);
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [dayOptions, setDayOption] = useState([]);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const tab = searchParams.get('findPassword') ? 1 : 0;
        setActiveTabIndex(tab);
    }, [searchParams]);

    const getMonths = (startMonth, endMonth) => {
        const months = [];
        for (let month = startMonth; month <= endMonth; month++) {
            months.push({
                value: month < 10 ? `0${month}` : String(month),
                option: month < 10 ? `0${month}` : String(month),
            });
        }
        return months;
    };

    const getDays = (month, year) => {
        let daysInMonth = 31;

        if ([4, 6, 9, 11].includes(month)) {
            daysInMonth = 30;
        } else if (month === 2) {
            if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
                daysInMonth = 29;
            } else {
                daysInMonth = 28;
            }
        }

        const days = [];
        for (let day = 1; day <= daysInMonth; day++) {
            days.push({
                value: day < 10 ? `0${day}` : String(day),
                option: day < 10 ? `0${day}` : String(day),
            });
        }
        return days;
    };
    const currentYear = moment().year() - 15;
    const yearOptions = generateYearOptions(currentYear - 100, currentYear);
    const monthOptions = getMonths(1, 12);

    const handleTabChange = (index) => {
        setActiveTabIndex(index);
        setPrepareData({
            residentNo: dateOfBirth,
        });
        const newTab = index === 1 ? '?findPassword=true' : '?findId=true';
        window.history.replaceState(null, '', newTab);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNo' && !/^\d*$/.test(value)) {
            return;
        }
        if (value === '') {
            setPrepareData((prevData) => ({
                ...prevData,
                [name]: undefined,
            }));
        } else {
            setPrepareData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = () => {
        if (activeTabIndex === 1 && !prepareData.memberID) {
            alert('아이디를 입력해 주세요.');
            handleFocus('memberID');
            return;
        }

        if (!prepareData.nameKor) {
            alert('이름을 입력해 주세요.');
            if (activeTabIndex === 0) handleFocus('nameKor');
            else if (activeTabIndex === 1) handleFocus('nameKor2');
            return;
        }

        if (!year || !month || !day) {
            alert('생년월일을 입력해 주세요.');
            if (!year) handleFocus('selectYear');
            else if (!month) handleFocus('selectMonth');
            else if (!day) handleFocus('selectDay');
            return;
        }
        if (!prepareData.mobileNo) {
            alert('휴대폰번호를 입력해 주세요.');
            if (activeTabIndex === 0) handleFocus('mobileNo');
            else if (activeTabIndex === 1) handleFocus('mobileNo2');
            return;
        }

        if (!prepareData.code) {
            alert('인증번호가 일치하지 않습니다.');
            if (activeTabIndex === 0) handleFocus('code');
            else if (activeTabIndex === 1) handleFocus('code2');
            return;
        }

        if (activeTabIndex === 0) {
            console.log('prepareData.code', prepareData.code);
            console.log('prepareData.secret', prepareData.secret);
            postPACAB010AuthOtp({ otp: prepareData.code, secret: prepareData.secret })
                .then(({ data }) => {
                    if (data === 'mismatch') {
                        alert('인증번호가 일치하지 않습니다.');
                    } else if (data === 'expired') {
                        alert('올바른 인증번호가 아닙니다.\n다시 발송해 주세요.');
                    } else if (data === 'success') {
                        alert('등록된 휴대폰번호로 발송되었습니다.');
                    }
                })
                .catch((error) => console.log(error));
        } else {
            postPACAC010AuthOtp({ otp: prepareData.code, memberID: prepareData.memberID })
                .then(({ data }) => {
                    if (data === 'mismatch') {
                        alert('인증번호가 일치하지 않습니다.');
                    } else if (data === 'expired') {
                        alert('올바른 인증번호가 아닙니다.\n다시 발송해 주세요.');
                    } else if (data === 'success') {
                        alert('등록된 휴대폰번호로 발송되었습니다.');
                    }
                })
                .catch((error) => console.log(error));
        }
    };

    useEffect(() => {
        const dateBirth = year + '' + month + '' + day;
        const dateOfBirth = moment(dateBirth, 'YYYYMMDD').format('YYMMDD');
        const years = Number(year) < 50 ? Number(year) + 2000 : Number(year) + 1900;
        setDateOfBirth(dateOfBirth);
        setPrepareData((prevData) => ({
            ...prevData,
            residentNo: dateOfBirth,
        }));
        setDayOption(getDays(Number(month), Number(years)));
    }, [day, month, year]);

    const handleAuthentication = () => {
        if (!prepareData.code) {
            if (activeTabIndex === 0)
                postPACAB010(prepareData)
                    .then(({ data }) => {
                        if (data === 'Not found') {
                            alert('등록된 회원이 아닙니다.');
                        } else {
                            setPrepareData((prevData) => ({
                                ...prevData,
                                secret: data,
                            }));
                            alert('인증번호가 발송되었습니다.\n인증번호 입력후 아이디 찾기버튼을 클릭하세요.');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            else {
                postPACAC010(prepareData)
                    .then(({ data }) => {
                        if (data === 'Not found') {
                            alert('등록된 회원이 아닙니다.');
                        } else if (data === 'success') {
                            alert('인증번호가 발송되었습니다.\n인증번호 입력후 비밀번호 찾기버튼을 클릭하세요.');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
    };
    return (
        <div id="content">
            {/* Search */}
            <div id="wrap-search">
                <div className="container">
                    {/* Title */}
                    <div id="title">
                        <div className="titleText" style={{ maxWidth: '1152px', margin: '0 auto', padding: '0px 25px' }}>아이디/비밀번호 찾기</div>
                    </div>
                    {/* End  Title */}
                    {/* start notification */}
                    <div id="instruct" className="notification">
                        <div className="group-notifi">
                            <div className="title-notifi">회원가입여부 확인 안내</div>
                            <ul className="title-notifi-child">
                                <li>회원정보에 등록된 정보를 입력하시면 아이디와 임시 비밀번호를 발송해 드립니다.</li>
                                <li>임시 비밀번호로 로그인하신 후 반드시 새로운 비밀번호로 변경하시기 바랍니다.</li>
                                <li>
                                    기타 문의사항은 080-801-1580(덴탈잡), 080-811-2201(덴탈비타민) 로 연락주시기
                                    바랍니다.
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* end notification */}
                    {/* start tab search*/}
                    <div id="tab-search">
                        <ul className="tabs">
                            <li>
                                <Link
                                    className={`${activeTabIndex === 0 && 'active'} black`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabChange(0);
                                    }}
                                >
                                    <i className="icon icon-glass" />
                                    아이디 찾기
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`${activeTabIndex === 1 && 'active'} black`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabChange(1);
                                    }}
                                >
                                    <i className="icon icon-glass" />
                                    비밀번호 찾기
                                </Link>
                            </li>
                        </ul>
                        <div className="tabs-content">
                            <div
                                id="search_id"
                                className={`tab-content-item tab-content-item-1 ${activeTabIndex === 0 && 'active'}`}
                            >
                                <form>
                                    <div className="form-row form-radio">
                                        <div className="title-form title-radio">회원구분</div>
                                        <div className="group-radio">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="options"
                                                    defaultValue="option1"
                                                    defaultChecked
                                                />
                                                <span className="title-value-radio">
                                                    DVmall, DV(덴탈비타민, 덴탈잡, 덴탈세미나) 통합회원
                                                </span>
                                            </label>
                                            <label>
                                                <input type="radio" name="options" defaultValue="option2" />
                                                <span className="title-value-radio">
                                                    DV(덴탈비타민, 덴탈잡, 덴탈세미나) 회원
                                                </span>
                                            </label>
                                            <label>
                                                <input type="radio" name="options" defaultValue="option3" />
                                                <span className="title-value-radio">DVmall 회원</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-row form-name">
                                        <div className="title-form title-name">이름</div>
                                        <div className="group-name">
                                            <input
                                                type="text"
                                                name="nameKor"
                                                className="wd249"
                                                placeholder="이름을 입력해 주세요."
                                                onChange={handleChange}
                                                value={prepareData.nameKor || ''}
                                                maxLength={20}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row form-birth">
                                        <div className="title-form title-birth">생년월일</div>
                                        <div className="group-birth wd375">
                                            <div className="group-form">
                                                <div
                                                    className="form-select-container select-year"
                                                    style={{ zIndex: '5' }}
                                                >
                                                    <Dropdown
                                                        placeholder="년"
                                                        options={yearOptions}
                                                        name="selectYear"
                                                        value={year}
                                                        onChange={(valueOption) => {
                                                            setYear(valueOption);
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-select-container select-month">
                                                    <Dropdown
                                                        placeholder="월"
                                                        options={monthOptions}
                                                        name="selectMonth"
                                                        value={month}
                                                        onChange={(valueOption) => {
                                                            setMonth(valueOption);
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-select-container select-day">
                                                    <Dropdown
                                                        placeholder="일"
                                                        options={dayOptions}
                                                        name="selectDay"
                                                        value={day}
                                                        onChange={(valueOption) => {
                                                            setDay(valueOption);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row form-phone">
                                        <div className="title-form title-phone">휴대폰번호</div>
                                        <div className="group-phone">
                                            <input
                                                type="text"
                                                name="mobileNo"
                                                placeholder="‘-’없이 입력하세요."
                                                onChange={handleChange}
                                                value={prepareData.mobileNo || ''}
                                                maxLength={20}
                                            />
                                            <button type="button" onClick={handleAuthentication}>
                                                인증번호 발송
                                            </button>
                                        </div>
                                        <div className="note-form-phone">
                                            ※ 회원가입시 등록한 휴대폰번호를 입력하세요.
                                        </div>
                                    </div>
                                    <div className="form-row form-otp">
                                        <div className="title-form title-otp">인증번호</div>
                                        <div className="group-otp">
                                            <input type="text" name="code" onChange={handleChange} />
                                            <div className="time-remaining-otp">(03:00)</div>
                                        </div>
                                    </div>
                                </form>
                                <button className="submit-form border-radius-10" type="button" onClick={handleSubmit}>
                                    아이디 찾기
                                </button>
                            </div>
                            <div
                                id="search_password"
                                className={`tab-content-item tab-content-item-2 ${activeTabIndex === 1 && 'active'}`}
                            >
                                <form action="post">
                                    <div className="form-row form-radio">
                                        <div className="title-form title-radio">회원구분</div>
                                        <div className="group-radio">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="options"
                                                    defaultValue="option1"
                                                    defaultChecked
                                                />
                                                <span className="title-value-radio">
                                                    DVmall, DV(덴탈비타민, 덴탈잡, 덴탈세미나) 통합회원
                                                </span>
                                            </label>
                                            <label>
                                                <input type="radio" name="options" defaultValue="option2" />
                                                <span className="title-value-radio">
                                                    DV(덴탈비타민, 덴탈잡, 덴탈세미나) 회원
                                                </span>
                                            </label>
                                            <label>
                                                <input type="radio" name="options" defaultValue="option3" />
                                                <span className="title-value-radio">DVmall 회원</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-row form-id">
                                        <div className="title-form title-id">아이디</div>
                                        <div className="group-id">
                                            <input
                                                type="text"
                                                name="memberID"
                                                className="wd249"
                                                placeholder="아이디를 입력해 주세요."
                                                onChange={handleChange}
                                                value={prepareData.memberID || ''}
                                                maxLength={12}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row form-name">
                                        <div className="title-form title-name">이름</div>
                                        <div className="group-name">
                                            <input
                                                type="text"
                                                name="nameKor"
                                                id="nameKor2"
                                                className="wd249"
                                                placeholder="이름을 입력해 주세요."
                                                onChange={handleChange}
                                                value={prepareData.nameKor || ''}
                                                maxLength={20}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row form-birth">
                                        <div className="title-form title-birth">생년월일</div>
                                        <div className="group-birth wd375">
                                            <div className="group-form">
                                                <div
                                                    className="form-select-container select-year"
                                                    style={{ zIndex: '5' }}
                                                >
                                                    <Dropdown
                                                        placeholder="년"
                                                        options={yearOptions}
                                                        name="selectYear"
                                                        value={year}
                                                        onChange={(valueOption) => {
                                                            setYear(valueOption);
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-select-container select-month">
                                                    <Dropdown
                                                        placeholder="월"
                                                        options={monthOptions}
                                                        name="selectMonth"
                                                        value={month}
                                                        onChange={(valueOption) => {
                                                            setMonth(valueOption);
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-select-container select-day">
                                                    <Dropdown
                                                        placeholder="일"
                                                        options={dayOptions}
                                                        name="selectDay"
                                                        value={day}
                                                        onChange={(valueOption) => {
                                                            setDay(valueOption);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row form-phone">
                                        <div className="title-form title-phone">휴대폰번호</div>
                                        <div className="group-phone">
                                            <input
                                                type="text"
                                                name="mobileNo"
                                                id="mobileNo2"
                                                placeholder="‘-’없이 입력하세요."
                                                onChange={handleChange}
                                                value={prepareData.mobileNo || ''}
                                                maxLength={20}
                                            />
                                            <button type="button" onClick={handleAuthentication}>
                                                인증번호 발송
                                            </button>
                                        </div>
                                        <div className="note-form-phone">
                                            ※ 회원가입시 등록한 휴대폰번호를 입력하세요.
                                        </div>
                                    </div>
                                    <div className="form-row form-otp">
                                        <div className="title-form title-otp">인증번호</div>
                                        <div className="group-otp">
                                            <input type="text" name="code" id="code2" onChange={handleChange} />
                                            <div className="time-remaining-otp">(03:00)</div>
                                        </div>
                                    </div>
                                </form>
                                <button className="submit-form border-radius-10" type="button" onClick={handleSubmit}>
                                    비밀번호 찾기
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PACAB010;
